import { auth, cauth, img } from './firebase'
import { setReAuthStatus, setEmailChangeStatus, setPasswordChangeStatus, setUsernameChangeStatus, setPictureChangeStatus } from './errorHandler.js'


export const getDefaultProfilePictureURL = (context) => {
    const myRef = img.ref()
    const myImageRef = myRef.child(`profilepictures/default.png`)
    myImageRef.getDownloadURL().then((url) => {
        context.setState({ defaultProfilePictureURL: url });
    })
}

export const registerAuthListener = (context) => {
    auth.onAuthStateChanged((user) => {
        if (user) {
            if (user.displayName == null)
                context.setState({ isUserLogged: true, username: 'My profile' })
            else
                context.setState({ isUserLogged: true, username: user.displayName })
        } else {
            context.setState({ isUserLogged: false, username: 'user' })
        }
    });
}

export const conditionalAuthListener = (context) => {
    auth.onAuthStateChanged((user) => {
        if (user) {
            context.setState({ isUserLogged: true })
        } else {
            context.setState({ isUserLogged: false })
        }
    });
}

export const getFullProfileInfo = (context) => {

    auth.onAuthStateChanged((user) => {
        if (user) {
            /*user.providerData.forEach((profile) => {
                if (profile.providerId.equals('facebook.com')) {
                    context.setState({
                        userLoginMethod: 'facebook'
                    })
                }
            });*/
            context.setState({
                username: user.displayName,
                userEmail: user.email,
                userPictureURL: user.photoURL,
                userUID: user.uid
            })
        } else {
            context.setState({ userProfileInfo: null })
        }
    });
}

export const doLogOut = () => {
    auth.signOut();
}

export const isLoggedIn = () => {
    if (auth.currentUser) {
        return true;
    }
    return false;
}

/* get profile informations */

export const getLoggedUserEmail = () => {
    return auth.currentUser.email;
}

export const getLoggedUserUsername = () => {
    return auth.currentUser.displayName;
}

export const getLoggedUserPhotoURL = () => {
    return auth.currentUser.photoURL;
}

export const getLoggedUserUID = () => {
    return auth.currentUser.uid;
}
/* update profile */

export const setUserUsername = (username, password, context) => {

    auth.currentUser.reauthenticateAndRetrieveDataWithCredential(
        cauth.EmailAuthProvider.credential(
            auth.currentUser.email,
            password
        )
    ).then(() => {
        auth.currentUser.updateProfile({
            displayName: username
        }).then(() => {
            context.setState({ ChangeUsernameStatusText: setUsernameChangeStatus("other/success") })
        }).catch((error) => {
            if (error.code != null)
                context.setState({ ChangeUsernameStatusText: setUsernameChangeStatus(error.code) })
        });
    }).catch((error) => {
        if (error.code != null)
            context.setState({ ChangeUsernameStatusText: setReAuthStatus(error.code) });
    });
}

export const setUserProfiePicture = (file, name, context) => {
    const metadata = { contentType: 'image/jpeg', }
    const uploadPictureRef = img.ref()
    context.setState({ ChangePictureStatusText: setPictureChangeStatus("other/uploading-started") })
    uploadPictureRef.child(`profilepictures/${name}`).put(file, metadata).then(() => {
        context.setState({ ChangePictureStatusText: setPictureChangeStatus("other/uploading-finished") })
        const getPictureURLRef = img.ref()
        const getDownloadURLRef = getPictureURLRef.child(`profilepictures/${name}`)
        getDownloadURLRef.getDownloadURL().then((url) => {
            auth.currentUser.updateProfile({
                photoURL: url
            });
            context.setState({ ChangePictureStatusText: setPictureChangeStatus("other/success") })
        })
    });
}

export const setUserEmail = (email, password, context) => {
    auth.currentUser.reauthenticateAndRetrieveDataWithCredential(
        cauth.EmailAuthProvider.credential(
            auth.currentUser.email,
            password
        )
    ).then(() => {
        auth.currentUser.updateEmail(email).then(() => {
            context.setState({ ChangeEmailStatusText: setEmailChangeStatus("other/success") })
        }).catch((error) => {
            if (error.code != null) context.setState({ ChangeEmailStatusText: setEmailChangeStatus(error.code) })
        });

    }).catch((error) => {
        if (error.code != null) context.setState({ ChangeEmailStatusText: setReAuthStatus(error.code) })
    });
}

export const setUserPassword = (newpassword, rnewpassword, oldpassword, context) => {

    auth.currentUser.reauthenticateAndRetrieveDataWithCredential(
        cauth.EmailAuthProvider.credential(
            auth.currentUser.email,
            oldpassword
        )
    ).then(() => {

        if (newpassword === rnewpassword) {
            auth.currentUser.updatePassword(newpassword).then(() => {
                context.setState({ ChangePasswordStatusText: setPasswordChangeStatus("other/success") })
            }).catch((error) => {
                if (error.code != null) context.setState({ changePasswordStatusText: setPasswordChangeStatus(error.code) })
            });
        }
        else {
            context.setState({ ChangePasswordStatusText: setPasswordChangeStatus("other/different-passwords") })
        }
    }).catch((error) => {
        if (error.code != null) context.setState({ ChangePasswordStatusText: setReAuthStatus(error.code) })
    });
}
